import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import "../Modals/styles/Modals.css";
const Teleport = ({ children }) => {
  const root = document.getElementById("root");
  const el = useRef(document.createElement("div"));
  useEffect(() => {
    // Capture the current element in a local variable
    const currentElement = el.current;

    if (root && currentElement) {
      root.appendChild(currentElement);
    }

    return () => {
      if (root && currentElement) {
        root.removeChild(currentElement);
      }
    };
  }, [root]);

  return ReactDOM.createPortal(children, el.current);
};

export default Teleport;
